import React from "react";

// Pasek przewijanych klientów (marquee). Akceptuje listę stringów LUB obiektów {name}
// (Puck trzyma elementy tablicy jako obiekty) — normalizujemy do stringów.
export function HomeClients({ clients = [] }) {
  const names = clients.map((c) => (typeof c === "string" ? c : (c && c.name) || ""));
  return (
    <section className="clients-strip">
      <div className="marquee">
        <div className="marquee-track">
          {Array(2).fill(0).flatMap((_, loop) =>
            names.map((t, i) => (
              <span key={`${loop}-${i}`} className="marquee-item">{t}</span>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
